import { useStaticQuery, graphql } from "gatsby";
import { useMemo } from "react";
import { isEmpty } from "lodash";

import { filterArticles, formatNewsArticle } from "~/utilities/format";

import useGetBasePath from "~/hooks/useGetBasePath";
import useAllDataHelper from "~/hooks/utils/useAllDataHelper";

const useFormatData = ({
    newsArticles,
    selectedCategories,
    categoryOptions,
}) => {
    const getBasePath = useGetBasePath();

    return useMemo(() => {
        const filteredArticles = !isEmpty(selectedCategories)
            ? filterArticles(newsArticles, selectedCategories, categoryOptions)
            : newsArticles;

        const formattedArticles = filteredArticles.map((article) =>
            formatNewsArticle(article, false, getBasePath),
        );

        return { formattedArticles, filteredArticles };
    }, [getBasePath, newsArticles, selectedCategories, categoryOptions]);
};

const useAllNewsArticles = (config = {}) => {
    const { selectedCategories, categoryOptions, initialFilter, limit } =
        config;

    const { allWpNewsArticle } = useStaticQuery(graphql`
        {
            allWpNewsArticle(sort: { date: DESC }) {
                nodes {
                    ...NewsArticleFragment
                }
            }
        }
    `);

    const newsArticles = useAllDataHelper(
        allWpNewsArticle.nodes,
        initialFilter,
    );

    const data = useFormatData({
        newsArticles,
        selectedCategories,
        categoryOptions,
    });

    const { formattedArticles } = data;

    if (limit > 0) {
        return {
            ...data,
            formattedArticles: formattedArticles.slice(0, limit),
        };
    }

    return data;
};

export default useAllNewsArticles;
